// extracted by mini-css-extract-plugin
export default {"txt1wrapper":"text_txt1wrapper__y8syg","txt1":"text_txt1__Jk8h0","txt2Wrapper":"text_txt2Wrapper__IdZvA","txt2":"text_txt2__8TdFx"};